module.exports = __webpack_public_path__ + "static/icon-0fb82b9046591018c59e16a5e7390709.png";